<script>

import mapboxgl from 'mapbox-gl';

const accessToken = 'pk.eyJ1IjoiZGFuaWVsYm9nZ3MiLCJhIjoiY2o1anY4NWJwMXV5cDJxbzF2dXBxMDZ2aSJ9.jWNar20rHwsZT62m7DQUmQ';
const mapStyle = 'mapbox://styles/mapbox/light-v9';

export default {
  props: {
    coords: ""
  },

  computed: {
    coordsArray () {
      return JSON.parse("[" + this.coords + "]");
    }
  },

  mounted () {
    const self = this;
    if (!!self.coords) {
      self.initializeMap();
    }
  },

  methods: {
    initializeMap () {
      const self = this;
      mapboxgl.accessToken = accessToken;

      const map = new mapboxgl.Map({
        container: self.$el.getAttribute('id'),
        style: mapStyle,
        center: self.coordsArray,
        zoom: 11,
        interactive: false
      });
    }
  }
}
</script>

<template lang="html">
  <div v-if="!!coords" id="DistrictBillboard-map" class="DistrictBillboard-map" data-coords="coords"></div>
</template>



// WEBPACK FOOTER //
// district-map.vue?850d42d0